module.exports = __webpack_public_path__ + "img/card1.06ca3865.png";